<template>
  <div class="zwyq">
    <div class="zwyq-title">
      <div>政务舆情服务</div>
      <p>优质资讯 优胜之道</p>
    </div>

    <div>
      <img />
    </div>

    <div class="zwyq-content">
      <p class="content-title">
        精讯凭借自主研发的数据平台，对海内外全网数据进行监测并提供实时舆情预警，深度舆情分析等服务。
      </p>
      <div class="content-wrap">
        <div class="item">
          <img class="item-img" src="@/assets/image/ico_zwyq1.png" />
          <div class="item-title">舆情监测</div>
          <p class="item-introduce">提供7*24小时全媒体监测服务，信息提供详细及时，全面客观。</p>
        </div>
        <div class="item">
          <img class="item-arrow" src="@/assets/image/ico_jiantou.png" />
          <img class="item-img" src="@/assets/image/ico_zwyq2.png" />
          <div class="item-title">舆情预警</div>
          <p class="item-introduce">负面信息自动判别，第一时间提供舆情服务。</p>
        </div>
        <div class="item">
          <img class="item-arrow" src="@/assets/image/ico_jiantou.png" />
          <img class="item-img" src="@/assets/image/ico_zwyq3.png" />
          <div class="item-title">舆情报告</div>
          <p class="item-introduce">提供舆情日报、周报、专报、年报等各种报告服务。</p>
        </div>
        <div class="item">
          <img class="item-img" src="@/assets/image/ico_zwyq6.png" />
          <div class="item-title">舆情分析</div>
          <p class="item-introduce">对舆情传播走势、媒体分布、发生发展过程等展开统计分析。</p>
        </div>
        <div class="item">
          <img class="turn" src="@/assets/image/ico_jiantou.png" />
          <img class="item-img" src="@/assets/image/ico_zwyq5.png" />
          <div class="item-title">舆情研究和应对</div>
          <p class="item-introduce">
            专业分析师团队，能够对舆情形式和热点事件进行分析研判，提出舆论引导和媒体运用建议。
          </p>
        </div>
        <div class="item">
          <img class="last" src="@/assets/image/ico_jiantou.png" />
          <img class="turn" src="@/assets/image/ico_jiantou.png" />
          <img class="item-img" src="@/assets/image/ico_zwyq6.png" />
          <div class="item-title">宣传推广效果追踪</div>
          <p class="item-introduce">对指定信息、平台的宣传效果进行，定性定量分析，并基于数据提出建议方案。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {}
  },
  methods: {},
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
@import '../../styles/global.less';
.zwyq-title {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 536px;
  background: url(~@/assets/image/back_zwyq.png) center no-repeat;
  background-size: 100% 100%;
  div {
    margin: 48px 0;
    font-size: 48px;
    font-weight: 600;
    color: #ffffff;
  }
  p {
    font-size: 24px;
    font-weight: 400;
    color: #ffffff;
    line-height: 28px;
  }
}
.zwyq-content {
  width: 80%;
  margin: 64px auto;
  .content-title {
    margin: 0 0 64px;
    font-size: 20px;
    font-weight: 400;
    color: #333333;
    line-height: 40px;
  }
  .content-wrap {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .item {
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 30%;
      min-height: 380px;
      margin: 30px 0;
      background: #ffffff;
      border-radius: 10px;
      box-shadow: 0px 0px 16px 0px #cfd8eb;
      .item-arrow {
        position: absolute;
        top: 15%;
        left: -20%;
        width: 162px;
      }
      .turn {
        position: absolute;
        top: 15%;
        left: -30%;
        width: 162px;
        transform: rotateY(-180deg) rotateX(-180deg);
      }
      .last {
        position: absolute;
        top: -5%;
        right: 0%;
        width: 162px;
        transform: rotateZ(90deg);
      }
      .item-img {
        width: 80px;
        height: 80px;
        margin: 40px auto 24px;
      }
      .item-title {
        margin: 20px 0;
        font-size: 24px;
        font-weight: 500;
        text-align: center;
        color: #333333;
      }
      .item-introduce {
        width: 80%;
        margin: 0 auto;
        font-size: 16px;
        text-align: center;
        color: #656565;
        line-height: 28px;
      }
    }
  }
}
</style>
